import { EOpenSidebar } from '@/constants/sidebar'

export interface SidebarState {
  openSidebar: EOpenSidebar | false
}

export const initialState: SidebarState = {
  openSidebar: false,
}
